if (!customElements.get('tab-contents')) {
  class TabContents extends HTMLElement {
    constructor() {
      super();

      this.tabTriggers = this.querySelectorAll('[data-tab-trigger]');
      this.tabTargets = this.querySelectorAll('[data-tab-target]');

      // get the tab triggers from other sections
      this.tabTriggersFromOtherSections = document.querySelectorAll(
        '[data-tab-outer-triggers] [data-tab-trigger]'
      );
      if (this.tabTriggersFromOtherSections.length > 0) {
        this.tabTriggers = [...this.tabTriggers, ...this.tabTriggersFromOtherSections];
      }

      // set the initial state of the tabs if there's already a hash in the URL
      this.init();

      // add event listeners to the tab triggers
      this.tabTriggers.forEach((tabTrigger) => {
        tabTrigger.addEventListener('click', (event) => {
          const hashWithoutHashtag = tabTrigger.href.split('#')[1];
          this.handleTabChange(hashWithoutHashtag, event);
        });
      });
    }

    /**
     * init
     * @description Set the initial state of the tabs if there's already a hash in the URL
     */
    init() {
      if (!window.location.hash) return;

      const hashWithoutHashtag = window.location.hash.replace('#', '');
      this.handleTabChange(hashWithoutHashtag);
    }

    /**
     * handleTabChange
     * @description Handle the change of the tab trigger selection
     */
    handleTabChange(hashWithoutHashtag, event = null) {
      const currentEventTarget = event ? event.currentTarget : '';
      let hasQuestionValue =
        currentEventTarget && currentEventTarget.dataset.tabQuestionToTarget ? true : false;
      let currentTabTarget;

      // update the state of the Active trigger (set the default style for the others)
      this.tabTriggers.forEach((tabTrigger) => {
        const tabTriggerHash = tabTrigger.href.split('#')[1];
        tabTrigger.classList.toggle('tab-trigger--active', tabTriggerHash == hashWithoutHashtag);
      });

      // update the visibility of the Active question group target (hide the others)
      this.tabTargets.forEach((tabTarget) => {
        tabTarget.classList.toggle('hidden', tabTarget.id != hashWithoutHashtag);

        // get the Active question group
        if (tabTarget.id == hashWithoutHashtag) currentTabTarget = tabTarget;
      });

      // handle individual questions visibility
      if (currentEventTarget) {
        this.handleQuestionsVisibility(currentEventTarget, currentTabTarget, hasQuestionValue);
      }
    }

    /**
     * handleQuestionsVisibility
     * @description Hide all questions and show the targeted question + Scroll into a Question if that's targeted
     */
    handleQuestionsVisibility(currentTabTrigger, currentTabTarget, scrollToQuestion = false) {
      let currentQuestion;

      // open the 1st question or the targeted question, and close all the others
      currentTabTarget.querySelectorAll('[data-collapsible-group]').forEach((question, index) => {
        question.classList.toggle(
          'collapsible-is-open',
          (index == 0 && scrollToQuestion == false) ||
            (scrollToQuestion && question.id == currentTabTrigger.dataset.tabQuestionToTarget)
        );

        // get the current question
        if (scrollToQuestion && question.id == currentTabTrigger.dataset.tabQuestionToTarget) {
          currentQuestion = question;
        }
      });

      // Scroll to the top of the question
      if (scrollToQuestion && currentQuestion) {
        // wait for any other questions to close to avoid conflict
        setTimeout(() => {
          const observerCallback = (payload) => {
            if (payload[0].isIntersecting) {
              currentQuestion.scrollIntoView(true);
              observerQuestionGroup.unobserve(currentTabTarget);
            }
          };
          const observerQuestionGroup = new IntersectionObserver(observerCallback);
          observerQuestionGroup.observe(currentTabTarget);
        }, 150);
      }
    }
  }

  customElements.define('tab-contents', TabContents);
}
